export const isInView = (element) => {
  const { top, right, bottom, left } = element.getBoundingClientRect();
  return top >= 0 && left >= 0 && right <= window.innerWidth && bottom <= window.innerHeight;
};
